import { getIdentityAuth } from '@guardian/identity-auth-frontend';
const getAuthStatus = async () => {
    const { isAuthenticated, accessToken, idToken } = await getIdentityAuth().isSignedInWithAuthState();
    if (isAuthenticated) {
        return {
            kind: 'SignedIn',
            accessToken,
            idToken,
        };
    }
    return {
        kind: 'SignedOut',
    };
};
const isUserLoggedIn = () => getIdentityAuth().isSignedIn();
/**
 * Get the user's Google Tag ID
 *
 * Returns the value from the ID token `google_tag_id` claim
 * @returns one of:
 * - string if the user signed in with Okta
 * - null if the user is signed out
 */
const getGoogleTagId = () => getAuthStatus().then((authStatus) => authStatus.kind === 'SignedIn'
    ? authStatus.idToken.claims.google_tag_id
    : null);
const getEmail = () => {
    return getAuthStatus().then((authStatus) => {
        if (authStatus.kind === 'SignedIn') {
            const email = authStatus.idToken.claims.email;
            return email;
        }
        return null;
    });
};
export { getAuthStatus, isUserLoggedIn, getGoogleTagId, getEmail };
